import isInboxPlusEnabled from 'owa-mail-inbox-plus-store/lib/selectors/isInboxPlusEnabled';
import { TableView } from 'owa-mail-list-store';
import { isNudgedRow } from 'owa-mail-nudge-store';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import { trace } from 'owa-trace';
import {
    getFocusedFilterForTable,
    getSelectedTableView,
    TableQueryType,
    MailRowDataPropertyGetter,
} from 'owa-mail-list-store';

/**
 * Determines whether to show Focused/Other rollup in mail list.
 * @param previousRowKey previous rowKey
 * @param currentRowKey current rowKey
 */
export default function shouldShowFocusedRollup(
    previousRowKey: string,
    currentRowKey: string
): boolean {
    if (!currentRowKey) {
        trace.error('shouldShowFocusedRollup: currentRowId is not expected to be null');
        return false;
    }

    if (isInboxPlusEnabled()) {
        // Inbox plus does not use the rollup UI to show unseen messages
        return false;
    }

    const tableView = getSelectedTableView();
    const isFolderTable = tableView.tableQuery.type === TableQueryType.Folder;
    if (!isFolderTable) {
        // Do not show focused roll up in non-folder tables
        return false;
    }

    if (getFocusedFilterForTable(tableView) === FocusedViewFilter.None) {
        // Do not show focused roll up in case of FocusedViewFilter.None
        return false;
    }

    if (isPinnedOrNudged(currentRowKey, tableView)) {
        // Do not show focused roll up if current row is pinned or nudged
        return false;
    }

    // Otherwise, when the current row is not pinned
    // Show focused roll up on top of list view if current row is the first row,
    // or if the previous row is pinned or nudged
    return previousRowKey === null || isPinnedOrNudged(previousRowKey, tableView);
}

function isPinnedOrNudged(rowKey: string, tableView: TableView): boolean {
    return (
        MailRowDataPropertyGetter.getIsPinned(rowKey, tableView) ||
        isNudgedRow(rowKey, tableView.id)
    );
}
